//icons
import UnitDishwasher from '@src/v3/assets/svg/unitDishwasher';
import Laundromat from '@src/v3/assets/svg/laundromat';
import DogSetting from '@src/v3/assets/svg/dogSetting';
import Balcony from '@src/v3/assets/svg/balcony';
import ParkingFlag from '@src/v3/assets/svg/parkingFlag';
import Doorman from '@src/v3/assets/svg/doorman';
import Gym from '@src/v3/assets/svg/gym';
import RoofDeck from '@src/v3/assets/svg/roofDeck';
import Elevator from '@src/v3/assets/svg/elevator';
import Pool from '@src/v3/assets/svg/pool';
import CookingPot from '@src/v3/assets/svg/cookingPot';
import { AmenitiesList } from '@src/v3/interfaces/components/wizard/register/workCommute';

export interface AmenityUI {
  icon: React.ElementType;
  name: string;
  key:
    | 'parking'
    | 'doorman'
    | 'gym'
    | 'Roof Deck'
    | 'roof_deck'
    | 'Elevator Building'
    | 'elevator'
    | 'In-Unit Dishwasher'
    | 'dishwasher'
    | 'Laundromat'
    | 'laundry_mat'
    | 'pet_friendly'
    | 'in_unit_laundry'
    | 'babysitting'
    | 'balcony'
    | 'Stainless Steel Appliances'
    | 'stainless_steel_appliances'
    | 'pool';
}

export const AMENITIES: AmenityUI[] = [
  {
    icon: ParkingFlag,
    name: 'Parking',
    key: 'parking',
  },
  {
    icon: Doorman,
    name: 'Doorman',
    key: 'doorman',
  },
  {
    icon: Gym,
    name: 'Gym',
    key: 'gym',
  },
  {
    icon: RoofDeck,
    name: 'Roof Deck',
    key: 'roof_deck',
  },
  {
    icon: Elevator,
    name: 'Elevator Building',
    key: 'elevator',
  },
  {
    icon: Pool,
    name: 'Pool',
    key: 'pool',
  },
  {
    icon: UnitDishwasher,
    name: 'In-Unit Dishwasher',
    key: 'dishwasher',
  },
  {
    key: 'laundry_mat',
    name: 'Laundromat',
    icon: Laundromat,
  },
  {
    key: 'in_unit_laundry',
    name: 'In-Unit Laundry',
    icon: Laundromat,
  },
  {
    key: 'pet_friendly',
    name: 'Pet Friendly',
    icon: DogSetting,
  },
  {
    key: 'stainless_steel_appliances',
    name: 'Stainless Steel Appliances',
    icon: CookingPot,
  },
  { key: 'balcony', name: 'Balcony', icon: Balcony },
];

// it's using in the Renter-Register and Add-property
export const AmenitiesGroupList: AmenitiesList[] = [
  { id: 'parking', value: 'parking', label: 'Parking', icon: ParkingFlag },
  { id: 'doorman', value: 'doorman', label: 'Doorman', icon: Doorman },
  {
    id: 'gym',
    value: 'gym',
    label: 'GYM',
    icon: Gym,
  },
  {
    id: 'roof_deck',
    value: 'roof_deck',
    label: 'Roof Deck',
    icon: RoofDeck,
  },
  {
    id: 'elevator',
    value: 'elevator',
    label: 'Elevator Building',
    icon: Elevator,
  },
  { id: 'pool', value: 'pool', label: 'Pool', icon: Pool },
  {
    id: 'dishwasher',
    value: 'dishwasher',
    label: 'In-Unit Dishwasher',
    icon: UnitDishwasher,
  },
  {
    id: 'laundry_mat',
    value: 'laundry_mat',
    label: 'Laundromat',
    icon: Laundromat,
  },
  //
  {
    id: 'pet_friendly',
    value: 'pet_friendly',
    label: 'Pet Friendly',
    icon: DogSetting,
  },
  {
    id: 'in_unit_laundry',
    value: 'in_unit_laundry',
    label: 'In-unit Laundry',
    icon: Laundromat,
  },
  { id: 'balcony', value: 'balcony', label: 'Balcony', icon: Balcony },
  {
    id: 'stainless_steel_appliances',
    value: 'stainless_steel_appliances',
    label: 'Stainless Steel Appliances',
    icon: CookingPot,
  },
];
